import { get, put } from './ApiService';
import { persistUserIdentity } from "./sessionIdentity";

export const getUserInfo = async (token) => {
  const response = await get('/user/profile', { token });
  if (response?.user) {
    persistUserIdentity(response.user);
  }
  return response.user;
};

export const updateUserInfo = async (userData) => {
  const response = await put('/user/profile', userData);
  if (response?.user) {
    persistUserIdentity(response.user);
  }
  return response;
};
